<template>
	<ChatHeader :isDM="false" :title="chat.displayname || chat.title">
		<div class="chat-header-details">
			<div class="chat-header-title" v-if="creator">
				<Mention :user="creator" :isMe="isMe(creator.id)" />
				{{
					$t('chat_stream_header_description_group_with_creator', {
						CreatedDate: createdAt,
					})
				}}
			</div>
			<div class="chat-header-title" v-else>
				{{
					$t('chat_stream_header_description_group_no_creator', {
						CreatedDate: createdAt,
					})
				}}
			</div>
		</div>
		<div class="chat-header-actions">
			<RouterLink
				v-if="canAddMember"
				:to="{ name: 'grouppeople', params: { id: chat.id } }"
			>
				<Button link class="add-person-button">
					<UserPlusIcon type="regular" />
					<span>{{ t('chat_stream_header_add_people_button') }}</span>
				</Button>
			</RouterLink>

			<RouterLink :to="{ name: 'groupnotifs', params: { id: chat.id } }">
				<Button link class="notification-settings-button">
					<BellIcon type="regular" />
					<span>{{ t('chat_stream_header_notifications_button') }}</span>
				</Button>
			</RouterLink>
		</div>
	</ChatHeader>
</template>

<script setup>
import { computed } from 'vue'
import { getUser, getCurrentChat, getMyUserId } from '@/store'
import ChatHeader from './ChatHeader'
import { Button } from '@/components/common'
import { UserPlusIcon, BellIcon } from '@/icons'
import moment from 'moment'
import { useI18n } from 'vue-i18n'
import { chatCan, ADD_MEMBER } from '@/helpers/permissions'
import Mention from '@/components/Message/Mention'

const { t } = useI18n()

//computed properties
const chat = computed(() => {
	return getCurrentChat()
})

const creator = computed(() => {
	return getUser(chat.value.user_id)
})

const createdAt = computed(() => {
	return moment(chat.value.created_at).local().format('M/D/YY')
})

const canAddMember = computed(() => {
	return chat.value ? chatCan(chat.value, ADD_MEMBER) : false
})

function isMe(user_id) {
	return user_id === getMyUserId()
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.chat-header-details {
	color: var(--neutral-800);
	font-family: Avenir-Medium;
	font-size: 17px;
	font-weight: 400;
	margin-top: 10px;
	margin-bottom: 5px;
	span {
		color: var(--blue-300);
		font-weight: 500;
		font-family: Avenir-Medium;
	}
	.chat-header-title {
		font-family: Avenir-Book;
	}
}

.chat-header-actions {
	display: flex;
	gap: 25px;
	.add-person-button,
	.notification-settings-button {
		padding: 0;
		color: var(--teal-300);
		font-size: 17px;
		&:hover {
			color: var(--teal-200) !important;
		}
		.pronto-icon {
			font-size: 18px;
		}
	}
}
</style>
